import { render, staticRenderFns } from "./ProductCost2.vue?vue&type=template&id=56c6ddfd&scoped=true&"
import script from "./ProductCost2.vue?vue&type=script&lang=js&"
export * from "./ProductCost2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6ddfd",
  null
  
)

export default component.exports